<template>
    <div class="w-[100%] flex justify-center mt-[24px] relative select-none">
        <div class="w-max ">
            <div class="relative w-full h-max">
                <img src="../../assets/field.svg" class="h-full w-full">

                <div class="absolute top-[23%] left-[50%] translate-x-[-50%]">
                    <div class="relative">
                        <div 
                            @click="changeAmpluaStatus('ЦФ')" 
                            class="bg-[#CA3F79] rounded-full w-[10px] z-30 h-[10px] border-[2px] cursor-pointer border-[#02130E]"
                            :class="{
                                'circle' : store.student.amplua == 'ЦФ',
                            }"    
                        ></div>
                        <div v-if="ampluaList['ЦФ'].status" class="w-[110px] mt-[2px] z-50 h-max absolute left-[50%] translate-x-[-50%]">
                            <div class="players-list h-[100px] w-full overflow-y-auto">
                                <div v-for="player in ampluaList['ЦФ'].players" class="flex w-[100px] mx-auto  relative mb-1">
                                    <div class="bg-[#5AC47D] w-[25px] truncate text-center text-[12px] px-1 font-semibold text-[#02130E]">
                                        <span class="relative top-[0.4px]">{{ player.number }}</span>
                                    </div>
                                    <div class="bg-[#02130E] w-[80px] truncate text-start text-[12px] px-2 text-[#FFF]">
                                        <span class="relative top-[0.4px]">{{ player.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="absolute top-[43%] left-[15%]">
                    <div class="relative">
                        <div 
                            @click="changeAmpluaStatus('ЛП')" 
                            class="bg-[#CA3F79] rounded-full w-[10px] z-30 h-[10px] border-[2px] cursor-pointer border-[#02130E]"
                            :class="{
                                'circle' : store.student.amplua == 'ЛП',
                            }"    
                        ></div>
                        <div v-if="ampluaList['ЛП'].status" class="w-[110px] mt-[2px] z-50 h-max absolute left-[50%] translate-x-[-50%]">
                            <div class="players-list h-[100px] w-full overflow-y-auto">
                                <div v-for="player in ampluaList['ЛП'].players" class="flex w-[100px] mx-auto  relative mb-1">
                                    <div class="bg-[#5AC47D] w-[25px] truncate text-center text-[12px] px-1 font-semibold text-[#02130E]">
                                        <span class="relative top-[0.4px]">{{ player.number }}</span>
                                    </div>
                                    <div class="bg-[#02130E] w-[80px] truncate text-start text-[12px] px-2 px-2 text-[#FFF]">
                                        <span class="relative top-[0.4px]">{{ player.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="absolute top-[47%] left-[50%] translate-x-[-50%]">
                    <div class="relative">
                        <div 
                            @click="changeAmpluaStatus('ЦП')" 
                            class="bg-[#CA3F79] rounded-full w-[10px] z-30 h-[10px] border-[2px] cursor-pointer border-[#02130E]"
                            :class="{
                                'circle' : store.student.amplua == 'ЦП',
                            }"    
                        ></div>
                        <div v-if="ampluaList['ЦП'].status" class="w-[110px] mt-[2px] z-50 h-max absolute left-[50%] translate-x-[-50%]">
                            <div class="players-list h-[100px] w-full overflow-y-auto">
                                <div v-for="player in ampluaList['ЦП'].players" class="flex w-[100px] mx-auto  relative mb-1">
                                    <div class="bg-[#5AC47D] w-[25px] truncate text-center text-[12px] px-1 font-semibold text-[#02130E]">
                                        <span class="relative top-[0.4px]">{{ player.number }}</span>
                                    </div>
                                    <div class="bg-[#02130E] w-[80px] truncate text-start text-[12px] px-2 px-2 text-[#FFF]">
                                        <span class="relative top-[0.4px]">{{ player.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="absolute top-[43%] right-[18%]">
                    <div class="relative">
                        <div 
                            @click="changeAmpluaStatus('ПП')" 
                            class="bg-[#CA3F79] rounded-full w-[10px] z-30 h-[10px] border-[2px] cursor-pointer border-[#02130E]"
                            :class="{
                                'circle' : store.student.amplua == 'ПП',
                            }"    
                        ></div>
                        <div v-if="ampluaList['ПП'].status" class="w-[110px] mt-[2px] z-50 h-max absolute left-[50%] translate-x-[-50%]">
                            <div class="players-list h-[100px] w-full overflow-y-auto">
                                <div v-for="player in ampluaList['ПП'].players" class="flex w-[100px] mx-auto  relative mb-1">
                                    <div class="bg-[#5AC47D] w-[25px] truncate text-center text-[12px] px-1 font-semibold text-[#02130E]">
                                        <span class="relative top-[0.4px]">{{ player.number }}</span>
                                    </div>
                                    <div class="bg-[#02130E] w-[80px] truncate text-start text-[12px] px-2 px-2 text-[#FFF]">
                                        <span class="relative top-[0.4px]">{{ player.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="absolute top-[63%] right-[17%]">
                    <div class="relative">
                        <div 
                            @click="changeAmpluaStatus('ПЗ')" 
                            class="bg-[#CA3F79] rounded-full w-[10px] z-30 h-[10px] border-[2px] cursor-pointer border-[#02130E]"
                            :class="{
                                'circle' : store.student.amplua == 'ПЗ',
                            }"    
                        ></div>
                        <div v-if="ampluaList['ПЗ'].status" class="w-[110px] mt-[2px] z-50 h-max absolute left-[50%] translate-x-[-50%]">
                            <div class="players-list h-[100px] w-full overflow-y-auto">
                                <div v-for="player in ampluaList['ПЗ'].players" class="flex w-[100px] mx-auto  relative mb-1">
                                    <div class="bg-[#5AC47D] w-[25px] truncate text-center text-[12px] px-1 font-semibold text-[#02130E]">
                                        <span class="relative top-[0.4px]">{{ player.number }}</span>
                                    </div>
                                    <div class="bg-[#02130E] w-[80px] truncate text-start text-[12px] px-2 px-2 text-[#FFF]">
                                        <span class="relative top-[0.4px]">{{ player.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="absolute top-[68%] left-[50%] translate-x-[-50%]">
                    <div class="relative">
                        <div 
                            @click="changeAmpluaStatus('ЦЗ')" 
                            class="bg-[#CA3F79] rounded-full w-[10px] z-30 h-[10px] border-[2px] cursor-pointer border-[#02130E]"
                            :class="{
                                'circle' : store.student.amplua == 'ЦЗ',
                            }"    
                        ></div>
                        <div v-if="ampluaList['ЦЗ'].status" class="w-[110px] mt-[2px] z-50 h-max absolute left-[50%] translate-x-[-50%]">
                            <div class="players-list h-[100px] w-full overflow-y-auto">
                                <div v-for="player in ampluaList['ЦЗ'].players" class="flex w-[100px] mx-auto  relative mb-1">
                                    <div class="bg-[#5AC47D] w-[25px] truncate text-center text-[12px] px-1 font-semibold text-[#02130E]">
                                        <span class="relative top-[0.4px]">{{ player.number }}</span>
                                    </div>
                                    <div class="bg-[#02130E] w-[80px] truncate text-start text-[12px] px-2 px-2 text-[#FFF]">
                                        <span class="relative top-[0.4px]">{{ player.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="absolute top-[63%] left-[15%]">
                    <div class="relative">
                        <div 
                            @click="changeAmpluaStatus('ЛЗ')" 
                            class="bg-[#CA3F79] rounded-full w-[10px] z-30 h-[10px] border-[2px] cursor-pointer border-[#02130E]"
                            :class="{
                                'circle' : store.student.amplua == 'ЛЗ',
                            }"    
                        ></div>
                        <div v-if="ampluaList['ЛЗ'].status" class="w-[110px] mt-[2px] z-50 h-max absolute left-[50%] translate-x-[-50%]">
                            <div class="players-list h-[100px] w-full overflow-y-auto">
                                <div v-for="player in ampluaList['ЛЗ'].players" class="flex w-[100px] mx-auto  relative mb-1">
                                    <div class="bg-[#5AC47D] w-[25px] truncate text-center text-[12px] px-1 font-semibold text-[#02130E]">
                                        <span class="relative top-[0.4px]">{{ player.number }}</span>
                                    </div>
                                    <div class="bg-[#02130E] w-[80px] truncate text-start text-[12px] px-2 px-2 text-[#FFF]">
                                        <span class="relative top-[0.4px]">{{ player.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="absolute top-[86%] left-[50%] translate-x-[-50%]">
                    <div class="relative">
                        <div 
                            @click="changeAmpluaStatus('ВР')" 
                            class="bg-[#CA3F79] rounded-full w-[10px] z-30 h-[10px] border-[2px] cursor-pointer border-[#02130E]"
                            :class="{
                                'circle' : store.student.amplua == 'ВР',
                            }"    
                        ></div>
                        <div v-if="ampluaList['ВР'].status" class="w-[110px] mt-[2px] z-50 h-max absolute left-[50%] translate-x-[-50%]">
                            <div class="players-list h-[100px] w-full overflow-y-auto">
                                <div v-for="player in ampluaList['ВР'].players" class="flex w-[100px] mx-auto  relative mb-1">
                                    <div class="bg-[#5AC47D] w-[25px] truncate text-center text-[12px] px-1 font-semibold text-[#02130E]">
                                        <span class="relative top-[0.4px]">{{ player.number }}</span>
                                    </div>
                                    <div class="bg-[#02130E] w-[80px] truncate text-start text-[12px] px-2 px-2 text-[#FFF]">
                                        <span class="relative top-[0.4px]">{{ player.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="absolute top-[0.3vw] right-[0.3vw]">
                    <div class="relative">
                        <div 
                            @click="changeAmpluaStatus('undefined')" 
                            class="bg-[#CA3F79] rounded-full w-[10px] z-30 h-[10px] border-[2px] cursor-pointer border-[#02130E]"
                            :class="{
                                'circle' : store.student.amplua == 'undefined',
                            }"    
                        ></div>
                        <div v-if="ampluaList['undefined'].status" class="w-[110px] mt-[2px] z-50 h-max absolute right-[2px]">
                            <div class="players-list h-[100px] w-full overflow-y-auto">
                                <div v-for="player in ampluaList['undefined'].players" class="flex w-[100px] mx-auto  relative mb-1">
                                    <div class="bg-[#5AC47D] w-[20px] truncate text-center text-[12px] px-1 font-semibold text-[#02130E]">
                                        <span class="relative top-[0.4px]">{{ player.number }}</span>
                                    </div>
                                    <div class="bg-[#02130E] w-[80px] truncate text-start text-[12px] px-2 px-2 text-[#FFF]">
                                        <span class="relative top-[0.4px]">{{ player.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ref, onMounted } from 'vue'
    import { useRouter } from 'vue-router'
    import { useMainStore } from '../../store/mainStore'

    export default {
        name: 'TeamField',

        setup() {
            const ampluaList = ref({
                'ВР' : {
                    status: true,
                    players: []
                },
                'ЦЗ' : {
                    status: true,
                    players: []
                },
                'ЛЗ' : {
                    status: true,
                    players: []
                },
                'ПЗ' : {
                    status: true,
                    players: []
                },
                'ЦП' : {
                    status: true,
                    players: []
                },
                'ПП' : {
                    status: true,
                    players: []
                },
                'ЛП' : {
                    status: true,
                    players: []
                },
                'ЦФ' : {
                    status: true,
                    players: []
                },
                'undefined' : {
                    status: true,
                    players: []
                }
            })
            const store = useMainStore()
            const router = useRouter()

            const changeAmpluaStatus = (amplua) => {
                // for (let key in ampluaList.value) {
                //     if (key !== amplua)
                //         ampluaList.value[key].status = false
                // }
                ampluaList.value[amplua].status = !ampluaList.value[amplua].status
            }

            onMounted(() => {
                try {
                    store.groupStudents.forEach((student) => {
                        if (Object.keys(ampluaList.value).includes(student.amplua)) {
                            ampluaList.value[student.amplua].players.push({
                                'name' : student.surname + ' ' + student.name.charAt(0) + '.',
                                'number' : student.player_number
                            })
                        } else {
                            ampluaList.value['undefined'].players.push({
                                'name' : student.surname + ' ' + student.name.charAt(0) + '.',
                                'number' : student.player_number
                            })
                        }
                    })
                } catch (e) {
                    router.push('/')
                }
            })

            return {
                ampluaList,
                changeAmpluaStatus,
                store
            }
        }
    }
</script>

<style lang="scss" scoped>
    .players-list::-webkit-scrollbar {
        width: 5px;               /* ширина всей полосы прокрутки */
    }

    .players-list::-webkit-scrollbar-track {
        background: transparent;        /* цвет зоны отслеживания */
    }

    .players-list::-webkit-scrollbar-thumb {
        background-color: rgba(37, 37, 38, 0.5);    /* цвет бегунка */
        border-radius: 20px;
    }

    .players-list {
        animation-iteration-count: 1;
    }

    .circle {
        animation: pulse 1.5s infinite;
    }
    
    .circle > * {
        pointer-events: none;
    }

    @keyframes pulse {
        0% {
            transform: scale(0.8);
            opacity: 0.8;
        }
        50% {
            transform: scale(1);
            opacity: 1;
        }
        100% {
            transform: scale(0.8);
            opacity: 0.8;
        }
    }

</style>